import { Checkbox } from "@vds/checkboxes";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "antd";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {
  createUserList,
  updateUserList,
  fetchOrganization,
  fetchRoles,
} from "../../../global/utility/Utils";
import { DeleteUserModal } from "../UserModal";
import { getRandomUUID } from "../../../Token";
import { deleteUserEndPoint } from "../../../configuration";
import Notification from "../../../global/components/notification/Notification";
import ValidationIcon, {
  getInputClassNames,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";

const CreateUser = (props) => {
  let navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  let { state } = useLocation();
  let smsChecked = false;

  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [deleteUserConfirmed, setDeleteUserConfirmed] = useState(false);
  const [organizationList, setOrganizationList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [typeNotific, setTypeNotific] = useState("error");
  const [msgNotific, setMsgNotific] = useState("");
  const [sendSMS, setSendSMS] = useState(smsChecked);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    organization: "",
    role: "",
    oldroleid: "",
  });

  const [errors, setErrors] = useState({
    firstName: "initial",
    lastName: "initial",
    email: "initial",
    mobileNumber: "initial",
    organization: "",
    role: "initial",
  });

  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "firstName":
        tempErrors.firstName = value ? "" : "First Name is required";
        break;
      case "lastName":
        tempErrors.lastName = value ? "" : "Last Name is required";
        break;
      case "email":
        tempErrors.email = /\S+@\S+\.\S+/.test(value)
          ? ""
          : "Email is not valid";
        break;
      case "mobileNumber":
        tempErrors.mobileNumber = /^(?:\+?\d{1,3}-?)?\d{10}$/.test(value)
          ? ""
          : "Mobile Number is not valid";
        break;
      case "role":
        tempErrors.role = value ? "" : "Role is required";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };

  const handleSubmit = async () => {
    let tempErrors = { ...errors };
    tempErrors.firstName = formData.firstName ? "" : "First Name is required";
    tempErrors.lastName = formData.lastName ? "" : "Last Name is required";
    tempErrors.email = /\S+@\S+\.\S+/.test(formData.email)
      ? ""
      : "Email is not valid";
      tempErrors.mobileNumber = /^(?:\+?\d{1,3}-?)?\d{10}$/.test(formData.mobileNumber)
      ? ""
      : "Mobile Number is not valid";
    tempErrors.role = formData.role ? "" : "Role is required";
    setErrors(tempErrors);
    if (Object.values(tempErrors).some((x) => x !== "")) {
      setTypeNotific("error");
      setMsgNotific("Invalid form data");
      setShowNotification(true);
    } else {
      if (selectedItem  && state?.createuser === undefined) {
        const response = await updateUserList({ ...formData });
        if (response?.status === 200 || response?.status === 204) {
          setTypeNotific("success");
          setMsgNotific("User Updated successfully");
          setShowNotification(true);
          setTimeout(() => {
            navigate("/users");
          }, 1000);
        } else {
          setTypeNotific("error");
          setMsgNotific("User Updated failed");
          setShowNotification(true);
        }
        setSelectedItem(null);
      } else {
        const newItem = { id: Date.now(), ...formData };
        const response = await createUserList(newItem, sendSMS);
        setDataList([...dataList, newItem]);
        if (response?.status === 200 || response?.status === 204) {
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: "",
            organization: "",
            role: "",
          });
          setTypeNotific("success");
          setMsgNotific("User created successfully");
          setShowNotification(true);
          setTimeout(() => {
            navigate("/users");
          }, 1000);
        } else {
          setTypeNotific("error");
          setMsgNotific("User creation failed");
          setShowNotification(true);
        }
      }
    }
  };
  const deleteUser = () => {
    setShowDeleteUser(true);
  };

  const onConfirm = async () => {
    setDeleteUserConfirmed(true);
    setShowDeleteUser(false);

    const response = await fetch(deleteUserEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        id: state?.id,
      }),
    });
    const deleteRuleRsp = await response;
    if (deleteRuleRsp) {
      if (deleteRuleRsp?.status === 200 || deleteRuleRsp?.status === 204) {
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNumber: "",
          organization: "",
          role: "",
        });
        setTypeNotific("success");
        setMsgNotific("User was deleted successfully");
        setShowNotification(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNumber: "",
          organization: "",
          role: "",
        });
        setTimeout(() => {
          navigate("/users");
        }, 1000);
      } else {
        setTypeNotific("error");
        setMsgNotific("User deleted failed");
        setShowNotification(true);
      }
    }
  };
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await fetchOrganization();

        if (data.length > 0) {
          setOrganizationList(
            data.filter(
              (d) =>
                d?.tags &&
                d?.tags.length > 0 &&
                d?.tags[0]?.kind === "ts.tag.org"
            )
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    const getRole = async () => {
      try {
        const data = await fetchRoles();
        let roles = [];
        if(user.role.name !== "SUPER_ADMIN"){
          roles = data.filter((d) => d.name !== "SUPER_ADMIN");
        }else{
          roles = data;
        }
        setRolesList(roles);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
    getRole();
  }, []);

  useEffect(() => {
    if (state) {
      if (user?.role?.permissions?.users?.edit) {
        if (state.hasOwnProperty("org_id")) {
          setSelectedItem({
            organization: state?.org_id,
          });
          setFormData({
            organization: state?.org_id,
          });
        } else {
          setSelectedItem({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
          });
          setFormData({
            firstName: state?.firstname,
            lastName: state?.lastname,
            email: state?.email,
            mobileNumber: state?.mdn,
            role: state?.customdata?.roleId,
            organization: state?.customdata?.orgId,
            oldroleid: state?.customdata?.roleId,
            id: state?.id,
          });
        }
      } else if (!user?.role?.permissions?.users?.create) {
        navigate("/users");
      }
    } else if (!user?.role?.permissions?.users?.create) {
      navigate("/users");
    }
  }, [state, user, navigate]);
  const handleClose = () => {
    setShowNotification(false);
  };

  const onExit = () => {
    setDeleteUserConfirmed(false);
    setShowDeleteUser(false);
    navigate(-1);
  };

  return (
    <>
      {showNotification && (
        <Notification
          title={
            state !== null && deleteUserConfirmed === true
              ? "DELETE USER"
              : state !== null
              ? "EDIT USER"
              : "ADD USER"
          }
          message={msgNotific}
          type={typeNotific}
          onClose={handleClose}
        />
      )}
      <div style={{ marginBottom: "10px" }}>
        <Link className="custom-link" to="/users">
          <h6 className="page-nav-heading">Users</h6>
        </Link>
        <h2 className={"font-face-vzb page-heading"}>
          {state !== null && state?.createuser === undefined  ? "EDIT USER" : "ADD USER"}
        </h2>
        <br />
        <h4>CONTACT INFORMATION</h4>
      </div>
      <>
        <Grid2
          container
          marginTop={1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={8} md={6} lg={6} direction="row">
            <>
              <div className="mb-3">
                <label htmlFor="firstName" className="input-label">
                  First Name
                </label>
                <div className="input-container">
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    className={getInputClassNames(
                      "firstName",
                      formData,
                      errors
                    )}
                  />
                  <ValidationIcon
                    fieldName="firstName"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <ErrorMessage fieldName="firstName" errors={errors} />
              </div>
              <div className="mb-3">
                <label htmlFor="lastName" className="input-label">
                  Last Name
                </label>
                <div className="input-container">
                  <input
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    className={getInputClassNames("lastName", formData, errors)}
                  />
                  <ValidationIcon
                    fieldName="lastName"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <ErrorMessage fieldName="lastName" errors={errors} />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="input-label">
                  Email address
                </label>
                <div className="input-container">
                  <input
                    id="email"
                    name="email"
                    disabled={!!selectedItem  && state?.createuser === undefined}
                    value={formData.email}
                    onChange={handleChange}
                    className={getInputClassNames("email", formData, errors)}
                  />
                  <ValidationIcon
                    fieldName="email"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <ErrorMessage fieldName="email" errors={errors} />
              </div>
              <div className="mb-3">
                <label htmlFor="mobileNumber" className="input-label">
                  Mobile Phone
                </label>
                <div className="input-container">
                  <input
                    id="mobileNumber"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    className={getInputClassNames(
                      "mobileNumber",
                      formData,
                      errors
                    )}
                  />
                  <ValidationIcon
                    fieldName="mobileNumber"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <ErrorMessage fieldName="mobileNumber" errors={errors} />
              </div>
              <h4>ASSOCIATIONS</h4>
              <div className="mb-3">
                <label htmlFor="organization" className="input-label">
                  Organization
                </label>
                <div className="input-container">
                  <select
                    id="organization"
                    style={{ width: "100%" }}
                    name="organization"
                    value={formData.organization}
                    onChange={handleChange}
                    className={getInputClassNames(
                      "organization",
                      formData,
                      errors
                    )}
                    aria-label=".form-select-lg example"
                  >
                    <option value="">Select Organization</option>
                    {organizationList.map((option, index) => (
                      <option
                        key={option.id}
                        value={option.id}
                        label={`${option.tags[0].org_name}`}
                      >
                        {option.tags[0].org_name}
                      </option>
                    ))}
                  </select>
                  <ValidationIcon
                    fieldName="organization"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <ErrorMessage fieldName="organization" errors={errors} />
              </div>
              <h4>PERMISSIONS</h4>
              <div className="mb-3">
                <label htmlFor="role" className="input-label">
                  Role
                </label>
                <div className="input-container">
                  <select
                    id="role"
                    style={{ appearance: "auto", backgroundColor: "white" }}
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    className={getInputClassNames("role", formData, errors)}
                    aria-label=".form-select-lg example"
                  >
                    <option value="">Select Role</option>
                    {rolesList?.map((option) => (
                      <option key={option?.name} value={option?.id}>
                        {option?.name?.toLowerCase()}
                      </option>
                    ))}
                  </select>
                  <ValidationIcon
                    fieldName="role"
                    formData={formData}
                    errors={errors}
                  />
                </div>
                <p>
                  The selected role applies to all organizations and locations
                  selected
                </p>
                <ErrorMessage fieldName="role" errors={errors} />
              </div>
              <div className="mb-3">
                <label htmlFor="twofactor" className="input-label">
                  Require two factor authentication
                </label>
                <div className="input-container">
                  <select
                    id="twofactor"
                    style={{ appearance: "auto" }}
                    disabled
                    name="twofactor"
                    value={formData.twofactor}
                    onChange={handleChange}
                    className={`form-control login-form-control`}
                    aria-label=".form-select-lg example"
                  >
                    <option value="1">NO</option>
                    <option value="2">YES</option>
                  </select>
                  {errors.twofactor && (
                    <p className="custom-error-message">{errors.twofactor}</p>
                  )}
                </div>
                {errors.twofactor && (
                  <i className="bi bi-exclamation-diamond input-icon-failure"></i>
                )}
                <p>
                  Forces user to enter code sent via email/SMS to login. Does
                  not apply to SSO users.
                </p>
              </div>
            </>
          </Grid2>
        </Grid2>
        {state === null || state?.createuser=== true ? (
          <Checkbox
            selected={sendSMS}
            onChange={(e) => {
              setSendSMS(!sendSMS);
            }}
          >
            Send Welcome email to the new user?
          </Checkbox>
        ) : (
          ""
        )}
        <br />
        <DeleteUserModal
          showDeleteUser={showDeleteUser}
          setShowDeleteUser={setShowDeleteUser}
          message="Are you sure want to delete the user?"
          title="Delete User"
          onConfirm={onConfirm}
          onExit={onExit}
        />
        <div xs={2} sm={2} md={2} lg={6}>
          <Button
            type="primary"
            onClick={handleSubmit}
            shape="round"
            style={{
              marginRight: "30%",
              backgroundColor: "black",
              color: "white",
              fontWeight: "bold",
            }}
            size={"large"}
          >
            {state !== null && state?.createuser === undefined ? "SAVE USER" : "ADD USER"}
          </Button>
          {state !== null && state?.createuser === undefined  && user?.role?.permissions?.users?.delete ? (
            <Button
              className="btn btn-outline-danger"
              type="danger"
              onClick={deleteUser}
              shape="round"
              style={{ fontWeight: "bold" }}
              size={"large"}
            >
              DELETE USER
            </Button>
          ) : (
            ""
          )}
        </div>
      </>
    </>
  );
};

export default CreateUser;
